module.exports = __webpack_public_path__ + "img/instruction_vieworder_3d.4698c6c0.png";